<template>
	<section>
    <editar-recurso />
		<crear-recurso />
		<v-card>
      <v-card-title>
         <v-toolbar-title>{{
           sistemSelected === 0 ? 'Selecciona un sistema' : rolSelected === 0 ? `Seleccione un rol` : 'Lista de recursos'
          }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-autocomplete
          :items="sistemas"
          item-text="descripcion"
          :item-value="val => parseInt(val.id)"
          label="Sistemas"
          :loading="sistemas.length === 0"
          @change="obtenerRoles"
        >
        </v-autocomplete>
        <v-autocomplete
          :items="roles"
          item-text="descripcion"
          :item-value="val => parseInt(val.id)"
          label="Roles"
          :loading="roles.length === 0 && sistemSelected !== 0"
          @change="obtenerRecursos"
          :disabled="sistemSelected === 0"
        >
        </v-autocomplete>
         <v-tooltip bottom>
          <v-btn color="primary" dark
            @click.native.stop="crearRecurso()"
            slot="activator"
            :disabled="sistemSelected === 0 || rolSelected === 0"
          ><v-icon dark>add</v-icon> {{$t('common.add') }}</v-btn>
          <span>Agregar recurso</span>
        </v-tooltip>            
      </v-card-title>

			<v-card-text>
        <v-data-table
          class="elevation-1"
          no-data-text='Seleccione un sistema para ver los roles'
          item-key="roles-by-sistem"
          :headers="headers"
          :items="recursos"
          rows-per-page-text='Filas por página'
          :rows-per-page-items="[5, 10, 25]"
          :rowsPerPageText="$t('common.rowsPage')"
        >
					<template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.descripcion }}</td>
						<td class="text-xs-center">{{ items.item.padre ? items.item.padre.descripcion : 'NO TIENE' }}</td>
						<td class="text-xs-center">{{ items.item.nivel }}</td>
						<td class="text-xs-center">{{ items.item.ruta }}</td>
						<td
							:title="items.item.icono"
              class="text-xs-center"
						>
							<v-icon>{{ items.item.icono }}</v-icon>
						</td>
            <td title="Activar/Desactivar recurso">
              <v-switch
                value
                :input-value="items.item.id_estado === '1' ? true : false"
                @change="cambiarEstado(items.item)"
              ></v-switch>
            </td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  color="primary"
                  slot="activator"
                  @click="editarRecurso(items.item)"
                  dark>
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>                
                <v-btn
                  icon
                  slot="activator"
                  color="error"
                  @click="eliminarRecurso(items.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import CrearRecurso from '../dialogs/CrearRecurso';
import EditarRecurso from '../dialogs/EditarRecurso.vue';

export default {
	mixins: [crud],
	data () {
		return {
			url: 'recursos',
			graphql: true,
			headers: [
        { text: this.$t('rol.crud.description'), value: 'descripcion', align: 'center' },
				{ text: 'Recurso Padre', value: 'id_padre', align: 'center' },
				{ text: 'Nivel', value: 'nivel', align: 'center' },
				{ text: 'Ruta', value: 'ruta', align: 'center' },
				{ text: 'Icono', value: 'icono', align: 'center' },
				{ text: 'Estado', value: 'id_estado', align: 'center' },
        { text: this.$t('common.actions'), sortable: false, align: 'center' }
      ],
			dataGraphql: `
        id
        descripcion
        id_estado
				icono
				ruta
				nivel
				id_padre
				padre{
          id
					descripcion
				}
				estado{
          id
					descripcion
				}
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
			filters: [
        {
          field: 'descripcion',
          label: 'Nombre del recurso',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'ruta',
          label: 'Ruta del recurso',
          type: 'text',
          typeG: 'String'
        }
      ],
      recursos: [],
      sistemas: [],
      sistemSelected: 0,
      rolSelected: 0,
      roles: [],
		}
	},
  mounted () {
    this.$bus.$on('closeDialog', () => this.obtenerRecursos(this.rolSelected))
    this.obtenerSistemas()
  },
	methods: {
		crearRecurso () {
			this.$bus.$emit('openDialogCrearRecurso', {recursos: this.recursos, rolSelected: this.rolSelected})
		},
    editarRecurso (item) {
      const recursos = this.recursos.filter(({id}) => id !== item.id)
      item.id_rol = this.rolSelected
      
      this.$bus.$emit('openDialogEditarRecurso', {item, recursos})
    },
    eliminarRecurso(item) {
       this.$confirm('¿Quiere eliminar el registro?', () => {
        this.$service.graphql({
          query: `
            mutation remove($id: Int!, $id_rol: Int!) {
              recursoDelete(id: $id, id_rol: $id_rol) {
                deleted
              }
            }
          `,
          variables: { id: parseInt(item.id), id_rol: this.rolSelected }
        }).then(()=> {
          this.$message.success('Registro eliminado correctamente');
          this.obtenerRecursos(this.rolSelected);
        })
      });


    },
		async cambiarEstado (item) {
      let value = parseInt(item.id_estado) === 20 ? 1 : 20
      let data = {
        id_estado: value
      }
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: Int!, $recurso: EditRecurso!) {
              recursoEdit(id: $id, recurso: $recurso) {
                id
              }
            }
          `,
          variables: {
            id: parseInt(item.id),
            recurso: data
          }
        })
        if (value === 1) {
          this.$message.success('Recurso habilitado')
        } else {
          this.$message.warning('Recurso deshabilitado')
        }
        this.obtenerRecursos(this.rolSelected)
      } catch (error) {
        console.log(error)
      }
    },
    async obtenerSistemas(){
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              sistemas{
                rows{
                  id
                  descripcion
                }
              }
            }
          `
        })
        this.sistemas = res.sistemas.rows
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    async obtenerRoles(idSistem){
      this.recursos = []
      this.sistemSelected = idSistem
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              roles(id_sistema: ${parseInt(idSistem)}){
                rows{
                  id
                  descripcion
                }
              }
            }
          `
        })
        this.roles = res.roles.rows
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },
    async obtenerRecursos(idRol){
      this.rolSelected = idRol
      try {
        this.loading = true
        let res = await this.$service.graphql({
          query: `
            query{
              recursos(id_sistema: ${parseInt(this.sistemSelected)}, id_rol: ${parseInt(idRol)}){
                rows{
                  id
                  descripcion
                  id_estado
                  icono
                  ruta
                  nivel
                  id_padre
                  padre{
                    id
                    descripcion
                    icono
                  }
                  estado{
                    descripcion
                  }
                }
              }
            }
          `
        })
        this.recursos = res.recursos.rows
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    }
	},
	components: {
		CrudTable,
		CrearRecurso,
    EditarRecurso
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/admin/rol-recurso/components/Recurso.vue